<template>
  <v-app-bar app dense>
    <!-- Ícone de menu: visível/oculto via miniActivate que o App controla -->
    <v-app-bar-nav-icon
      v-if="miniActivate"
      @click="propMini"
    ></v-app-bar-nav-icon>

    <Transition>
      <v-toolbar-title
        v-show="isMini"
        class="primary--text"
      >
        <router-link to="/">
          <v-avatar
            height="28"
            width="80"
            tile
            class="mt-2 mb-2"
          >
            <img src="@/assets/fundo_conduril.png" />
          </v-avatar>
        </router-link>
      </v-toolbar-title>
    </Transition>

    <v-spacer></v-spacer>

    <!-- Sino de notificação com animação -->
    <v-btn
      icon
      :color="alertHasData ? 'orange darken-2' : 'danger'"
      elevation
      @click="notificationDialog = true"
      :class="{
        'bell-animation':
          alertHasData &&
          showBellAnimation
      }"
    >
      <v-icon v-if="!alertHasData">
        mdi-bell
      </v-icon>

      <v-icon v-else>
        mdi-bell-badge
      </v-icon>
    </v-btn>

    <v-dialog
      v-model="notificationDialog"
      transition="dialog-top-transition"
      max-width="800px"
      scrollable
    >
      <NotificationList
        v-if="notificationDialog"
        :messages="alerts"
        @refresh="refreshHeader"
      />
    </v-dialog>

    <v-btn
      link
      to="/perfil"
      icon
      color="primary"
    >
      <v-icon>
        mdi-account
      </v-icon>
    </v-btn>

    <AppLauncherButton
      v-if="false"
      :launcher-url="getLauncherURL"
      icon="mdi-apps"
      color="primary"
      tooltip-text="Voltar ao menu de aplicações"
      :show-confirmation="true"
      confirmation-title="Voltar ao menu?"
      confirmation-text="Vai voltar ao menu central de aplicações. Pretende continuar?"
    />
  </v-app-bar>
</template>

<script>
import NotificationList from "@/components/UI/Modals/NotificationList";

export default {
  name: "AppBar",

  components: {
    NotificationList,
  },

  props: {
    isMini: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      alerts: [],
      alertHasData: false,
      notificationDialog: false,
      miniActivate: true,
      showBellAnimation: true,
      loading: false,
      error: false,
      success: false,
    };
  },

  mounted() {
    this.getAlerts();

    /*
     * Desativa a animação do sino
     * após alguns segundos.
     */
    setTimeout(() => {
      this.showBellAnimation = false;
    }, 3000);
  },

  computed: {
    getLauncherURL() {
      return process.env.VUE_APP_LAUNCHER_URL;
    },
  },

  methods: {
    /*
     * Alterna o mini do layout via .sync.
     *
     * Desktop:
     * alterna mini.
     *
     * Mobile:
     * abre/fecha a modal do menu.
     */
    propMini() {
      if (this.$vuetify.breakpoint.width > 960) {
        this.$emit(
          "update:isMini",
          !this.isMini
        );

        return;
      }

      this.$emit("toggle-drawer");
    },

    /*
     * Permite ao componente pai
     * esconder o ícone do menu.
     */
    changeMiniDeactivate() {
      this.miniActivate = false;
    },

    /*
     * Permite ao componente pai
     * mostrar o ícone do menu.
     */
    changeMiniActivate() {
      this.miniActivate = true;
    },

    refreshHeader() {
      this.getAlerts();

      this.notificationDialog = false;
      this.notificationDialog = true;
    },

    getAlerts() {
      this.$store
        .dispatch("getAlerts")
        .then((res) => {
          this.success = true;
          this.alerts = [];

          if (
            res.data.lastCreationDataExpired === true
          ) {
            this.alerts.push({
              id: "ND",
              title: "Criação de PD",
              subtitle: "Sem atividade",
              encarregado: "System",
              text:
                "Não são encontrados registos de partes diárias há muito tempo",
              diary_creation_role: null,
              extraLink: null,
              diaria: null,
              id_user_creator: null,
            });
          }

          const notifications =
            res.data.notifications || [];

          if (notifications.length >= 1) {
            notifications.forEach((not) => {
              this.alerts.push({
                id: not.ns_id,
                title: not.title,
                subtitle: "",
                encarregado: not.creationRole,
                diary_creation_role:
                  not.diary_creation_role,
                text: not.descricao,
                extraLink:
                  not.pd_id +
                  "/" +
                  not.webAppHashLink,
                diaria: not.diaria,
                id_user_creator:
                  not.id_user_creator,
              });
            });
          }

          this.alertHasData =
            this.alerts.length >= 1;

          this.error = false;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
/*
 * Animação para o sino de notificação.
 */
@keyframes bellSwingBlink {
  0% {
    transform: rotate(0deg);
    opacity: 1;
  }

  25% {
    transform: rotate(-30deg);
    opacity: 0.5;
  }

  50% {
    transform: rotate(0deg);
    opacity: 1;
  }

  75% {
    transform: rotate(30deg);
    opacity: 0.5;
  }

  100% {
    transform: rotate(0deg);
    opacity: 1;
  }
}

/*
 * Classe que ativa a animação.
 */
.bell-animation {
  animation: bellSwingBlink 0.5s ease-in-out 6;
}
</style>